import React from "react";

export class ForgotPasswordMail extends React.Component<any, any> {

    render() {
        return (
            <div>
               <h3>Forgotten password</h3>
                <p>
                    Dear, András!<br/>
                    Please click on the link below to renew your password.
                </p>
                <a href={'https://hub-bravo.hu/new-password/my-hash'} target={'blank'}>
                    https://hub-bravo.hu/new-password/my-hash
                </a>
            </div>
        );
    };
}
